export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])?$/;

export const SLUG_MIN_LENGTH = 3;

export const SLUG_MAX_LENGTH = 63;

export const SLUG_FORMAT_MESSAGE =
  'Use 3–63 lowercase letters, numbers or hyphens. It must start and end with a letter or number.';

export const SLUG_RESERVED_MESSAGE = 'This URL is reserved.';

export const RESERVED_SLUGS = [
  'www',
  'api',
  'admin',
  'app',
  'apps',
  'static',
  'media',
  'mail',
  'mock',
  'mocks',
  'auth',
  'login',
  'evolve',
  'evolveai',
  'appstore',
  'broker',
  'dev',
  'test',
  'qa',
  'staging',
  'prod',
  'production',
  'help',
  'support',
  'status',
  'docs',
  'assets',
  'cdn',
];

export const normalizeSlugInput = (value: string) =>
  value.toLowerCase().replace(/\s+/g, '-').slice(0, SLUG_MAX_LENGTH);

export const slugify = (value: string) =>
  value
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SLUG_MAX_LENGTH)
    .replace(/-+$/g, '');

export type SlugFormatResult =
  | { valid: true; reason: null; message: null }
  | {
      valid: false;
      reason: 'required' | 'invalid' | 'reserved';
      message: string;
    };

export const checkSlugFormat = (slug: string): SlugFormatResult => {
  if (!slug)
    return {
      valid: false,
      reason: 'required',
      message: 'Choose a URL for your hosted application.',
    };
  if (slug.length < SLUG_MIN_LENGTH || !SLUG_PATTERN.test(slug))
    return { valid: false, reason: 'invalid', message: SLUG_FORMAT_MESSAGE };
  if (RESERVED_SLUGS.includes(slug.toLowerCase()))
    return { valid: false, reason: 'reserved', message: SLUG_RESERVED_MESSAGE };
  return { valid: true, reason: null, message: null };
};

export const hostedUrlFor = (slug: string, suffix: string) =>
  `https://${slug}${suffix}`;
